import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const CarParts: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M90.9291 134.594L137.301 126.204L92.2911 112.614L58.5798 118.588L90.9291 134.594Z"
      fill="url(#car_parts_paint0_linear)"
    />
    <path
      d="M112.836 96.2383C108.371 96.7288 104.194 96.0826 100.424 94.6889C98.8416 90.755 97.9335 86.425 97.9305 81.7857C97.923 72.5708 101.33 63.7976 106.976 56.7222C111.974 50.4593 118.726 45.5272 126.418 42.7953C134.998 46.649 140.891 54.9384 140.966 65.2946C141.08 80.6654 128.485 94.5189 112.836 96.2383ZM119.094 21.0928C91.8185 24.0906 69.8653 48.2367 70.0616 75.0256C70.2571 101.814 92.528 121.101 119.804 118.104C147.08 115.106 169.033 90.9602 168.838 64.1713C168.641 37.3824 146.37 18.095 119.094 21.0928ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#28201E"
    />
    <path
      d="M111.023 122.359L93.1394 113.393L106.13 107.77L111.023 122.359ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#28201E"
    />
    <path
      d="M145.452 25.6452L163.435 34.7868L144.506 40.4026L145.452 25.6452ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#28201E"
    />
    <path
      d="M112.836 96.2383C108.371 96.7288 104.194 96.0825 100.424 94.6889C98.8416 90.755 97.9335 86.425 97.9305 81.7857C97.923 72.5707 101.33 63.7976 106.976 56.7222C111.974 50.4593 118.727 45.5272 126.418 42.7953C134.998 46.649 140.891 54.9376 140.966 65.2939C141.08 80.6646 128.485 94.5189 112.836 96.2383ZM135.796 29.3574C108.501 32.1777 86.3927 56.1808 86.4137 82.9704C86.4355 109.76 108.58 129.191 135.874 126.371C163.169 123.551 185.279 99.5476 185.257 72.758C185.236 45.9683 163.091 26.5372 135.796 29.3574ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#393939"
    />
    <path
      d="M98.1935 77.41C98.165 77.6549 98.1336 77.899 98.1096 78.1454C98.1336 77.899 98.165 77.6549 98.1935 77.41ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M98.455 75.5558C98.4108 75.8216 98.3658 76.0867 98.3276 76.3541C98.3658 76.0867 98.4108 75.8216 98.455 75.5558ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M98.0182 79.3481C98.0047 79.551 97.9867 79.754 97.977 79.9577C97.9867 79.754 98.0047 79.551 98.0182 79.3481ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M98.0751 84.8673C98.0369 84.4382 98.001 84.0069 97.9792 83.5718C98.0002 84.0076 98.0384 84.4375 98.0751 84.8673ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M135.857 40.6123C119.638 42.2876 105.811 53.7057 100.388 68.3156C101.943 64.1376 104.184 60.2225 106.976 56.723C111.974 50.4601 118.727 45.5272 126.418 42.7961C134.998 46.6498 140.892 54.9384 140.967 65.2954C141.08 80.6654 128.485 94.5189 112.836 96.2383C108.371 96.7288 104.195 96.0833 100.425 94.6889C99.2424 91.7503 98.4377 88.59 98.1043 85.2455C99.9077 104.003 116.149 117.158 135.916 115.117C156.879 112.951 173.859 94.5166 173.842 73.9427C173.826 53.3687 156.819 38.4466 135.857 40.6123ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M100.325 68.4751C100.186 68.8533 100.059 69.2367 99.9317 69.6194C100.059 69.2367 100.186 68.8533 100.325 68.4751ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M98.8018 73.7405C98.7404 74.0236 98.6812 74.3066 98.6265 74.5912C98.6812 74.3066 98.7404 74.0236 98.8018 73.7405ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M99.7383 70.2013C99.6342 70.53 99.5383 70.8618 99.4432 71.1943C99.5383 70.8618 99.6342 70.53 99.7383 70.2013ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M99.2296 71.9567C99.1495 72.2585 99.0738 72.5625 99.0011 72.8665C99.0738 72.5625 99.1495 72.2585 99.2296 71.9567ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M132.386 42.7953L130.239 70.4904H143.057L139.992 42.7953H132.386ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#C8C9C8"
    />
    <path
      d="M100.763 71.702L126.663 83.3456L130.487 69.5984L103.078 64.4604L100.763 71.702ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#C8C9C8"
    />
    <path
      d="M135.53 87.0556L156.658 105.833L162.25 100.679L145.438 78.5453L135.53 87.0556ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#C8C9C8"
    />
    <path
      d="M170.27 63.1416L145.291 82.3578L138.443 71.0842L166.322 56.6428L170.27 63.1416ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#C8C9C8"
    />
    <path
      d="M137.49 87.609L115.035 110.522L109.085 105.785L126.448 79.6229L137.49 87.609ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#C8C9C8"
    />
    <path
      d="M135.913 110.027C117.815 111.897 103.132 99.0129 103.117 81.2495C103.103 63.4868 117.763 47.5709 135.861 45.701C153.958 43.831 168.642 56.7155 168.656 74.4781C168.671 92.2415 154.01 108.157 135.913 110.027ZM135.858 40.6116C114.895 42.7773 97.9148 61.2118 97.9313 81.7857C97.9485 102.36 114.954 117.282 135.916 115.117C156.878 112.95 173.857 94.5166 173.842 73.9427C173.825 53.3687 156.818 38.4458 135.858 40.6116ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#E4E4E4"
    />
    <path
      d="M148.359 76.5705C148.364 83.3583 142.762 89.4407 135.846 90.1559C128.929 90.8704 123.318 85.9465 123.313 79.1586C123.307 72.37 128.909 66.2876 135.825 65.5732C142.742 64.8588 148.353 69.7827 148.359 76.5705ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#C8C9C8"
    />
    <path
      d="M139.681 77.4669C139.683 79.551 137.962 81.418 135.839 81.6374C133.715 81.8568 131.992 80.3464 131.991 78.2622C131.989 76.1781 133.709 74.3104 135.832 74.0917C137.956 73.8723 139.679 75.3828 139.681 77.4669ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M137.491 69.382C137.492 70.0028 136.979 70.5585 136.348 70.6237C135.715 70.6888 135.201 70.2395 135.201 69.6187C135.201 68.9978 135.713 68.4422 136.345 68.377C136.977 68.3119 137.491 68.7612 137.491 69.382ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M131.222 85.7188C131.222 86.3396 130.71 86.8953 130.078 86.9604C129.446 87.0264 128.932 86.577 128.931 85.9562C128.931 85.3354 129.444 84.779 130.076 84.7138C130.708 84.6487 131.221 85.0987 131.222 85.7188ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M143.258 84.5888C143.258 85.2096 142.744 85.766 142.113 85.8311C141.48 85.8963 140.967 85.4462 140.967 84.8254C140.966 84.2046 141.479 83.6497 142.111 83.5845C142.743 83.5186 143.257 83.9679 143.258 84.5888ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M145.651 75.2442C145.651 75.8651 145.14 76.4207 144.508 76.4859C143.876 76.551 143.362 76.1017 143.361 75.4809C143.36 74.8601 143.873 74.3044 144.505 74.2392C145.137 74.1741 145.65 74.6234 145.651 75.2442ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M127.879 75.8081C127.879 76.429 127.367 76.9854 126.735 77.0505C126.103 77.1157 125.589 76.6649 125.588 76.0448C125.587 75.424 126.1 74.869 126.732 74.8039C127.364 74.738 127.878 75.1873 127.879 75.8081ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M156.246 154.453L187.661 148.859L159.558 134.897L128.142 140.49L156.246 154.453Z"
      fill="url(#car_parts_paint1_linear)"
    />
    <path d="M187.661 113.31V148.859L159.557 134.897V99.3477L187.661 113.31Z" fill="#C39000" />
    <path d="M187.661 113.31V148.859L237.035 140.016V104.467L187.661 113.31Z" fill="#FBCE08" />
    <path d="M157.581 101.776L187.118 116.451L239.015 107.157L209.476 92.4819L157.581 101.776Z" fill="#393939" />
    <path d="M157.581 99.1845L187.118 113.859L239.015 104.565L209.476 89.8901L157.581 99.1845Z" fill="#706D6D" />
    <path
      d="M215.893 100.553C217.41 99.8898 219.966 99.8704 221.598 100.509C223.232 101.149 223.325 102.205 221.808 102.869C220.29 103.532 217.735 103.552 216.102 102.912C214.47 102.274 214.376 101.218 215.893 100.553Z"
      fill="black"
    />
    <path d="M214.82 93.5582C214.817 93.5777 214.82 101.712 214.82 101.712H222.888V93.5582" fill="black" />
    <path
      d="M215.893 92.4003C217.41 91.7367 219.966 91.7165 221.598 92.3561C223.232 92.9949 223.325 94.0523 221.808 94.715C220.29 95.3785 217.735 95.398 216.102 94.7592C214.47 94.1197 214.376 93.0638 215.893 92.4003Z"
      fill="#393939"
    />
    <path d="M198.424 124.252V132.76L200.444 132.35V123.83L198.424 124.252Z" fill="black" />
    <path d="M194.967 130.061L203.478 128.548L203.492 126.527L194.967 128.04V130.061Z" fill="black" />
    <path d="M222.06 125.217L230.572 123.704L230.584 121.684L222.06 123.196V125.217Z" fill="black" />
    <path d="M176.459 95.8713L210.007 90.1297L201.36 85.8379L167.812 91.5795L176.459 95.8713Z" fill="#706D6D" />
    <path d="M176.459 95.9142V102.034L167.811 97.6987V91.5797L176.459 95.9142Z" fill="#28201E" />
    <path d="M176.459 95.914V102.034L186.347 100.194V94.0747L176.459 95.914Z" fill="#393939" />
    <path d="M186.348 94.074V99.9407L210.007 95.9948V90.1289L186.348 94.074Z" fill="#393939" />
    <path d="M205.21 103.445V109.564L216.84 107.485V101.366L205.21 103.445Z" fill="#393939" />
    <path d="M205.21 103.445V109.564L186.347 100.192V94.0732L205.21 103.445Z" fill="#28201E" />
    <path d="M205.21 103.345L216.84 101.366L189.422 87.8562L177.791 89.834L205.21 103.345Z" fill="#706D6D" />
    <path d="M157.58 99.1843V101.82L187.118 116.452V113.859L157.828 99.1394" fill="#28201E" />
    <path d="M239.014 104.564V107.157L235.052 105.274L239.014 104.564Z" fill="#393939" />
    <path
      d="M184.453 106.299C185.971 105.635 188.525 105.615 190.158 106.254C191.792 106.893 191.886 107.95 190.368 108.614C188.85 109.277 186.295 109.297 184.662 108.657C183.029 108.019 182.936 106.962 184.453 106.299Z"
      fill="#860310"
    />
    <path d="M183.38 99.3027C183.377 99.3221 183.38 107.456 183.38 107.456H191.447V99.3027" fill="#860310" />
    <path
      d="M184.453 98.145C185.971 97.4808 188.525 97.4613 190.158 98.1001C191.792 98.7396 191.886 99.7963 190.368 100.46C188.85 101.123 186.295 101.143 184.662 100.503C183.029 99.8652 182.936 98.8085 184.453 98.145Z"
      fill="#D30511"
    />
    <path
      d="M72.2336 163.313L107.152 157.056L52.1354 130.804L18.5492 136.841L72.2336 163.313Z"
      fill="url(#car_parts_paint2_linear)"
    />
    <path
      d="M45.2973 112.959C43.8753 112.262 43.5816 111.29 42.9867 109.345C42.2615 106.952 41.2665 103.674 37.1849 101.676C33.1069 99.6727 29.9048 100.896 27.5471 101.793C25.6636 102.511 24.7241 102.878 23.2991 102.174L15.783 97.7009L12.3434 102.854L19.4189 107.337L20.5038 107.868C24.5855 109.866 27.7838 108.651 30.1228 107.758C32.151 106.985 33.023 106.701 34.3903 107.371C35.7606 108.041 36.0686 108.908 36.7024 110.992C37.4306 113.382 38.4293 116.658 42.5027 118.653L47.7419 121.329L50.4031 115.503L45.2973 112.959ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M17.1241 100.001C17.1249 101.629 15.7823 103.087 14.125 103.258C12.4671 103.43 11.1222 102.249 11.1207 100.621C11.1192 98.9942 12.4626 97.5369 14.1198 97.3654C15.7778 97.1946 17.1226 98.3741 17.1241 100.001ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M64.187 111.092L111.027 134.604L101.541 156.353L50.1199 130.667L64.187 111.092ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#C39000"
    />
    <path
      d="M118.502 144.478C118.507 150.777 113.309 156.422 106.891 157.085C100.473 157.748 95.2663 153.179 95.2611 146.881C95.2559 140.582 100.455 134.937 106.872 134.275C113.29 133.611 118.497 138.179 118.502 144.478ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#FBCE08"
    />
    <path
      d="M68.9332 119.778C68.9385 126.077 63.7397 131.721 57.322 132.384C50.9043 133.048 45.6973 128.478 45.6921 122.179C45.6876 115.88 50.8864 110.237 57.3041 109.574C63.721 108.911 68.928 113.479 68.9332 119.778ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#C39000"
    />
    <path
      d="M109.064 144.044L141.234 159.749L138.143 164.819L105.555 148.926L109.064 144.044ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <path
      d="M142.917 162.16C142.918 163.731 141.621 165.139 140.021 165.304C138.42 165.469 137.122 164.329 137.12 162.759C137.119 161.188 138.415 159.78 140.016 159.615C141.617 159.45 142.915 160.589 142.917 162.16ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="black"
    />
    <path
      d="M110.05 146.088C110.051 147.659 108.754 149.067 107.154 149.232C105.553 149.397 104.255 148.258 104.253 146.687C104.252 145.115 105.548 143.708 107.149 143.543C108.75 143.377 110.049 144.516 110.05 146.088ZM11.1207 165.319H239.014V20.7858H11.1207V165.319ZM11.1207 20.7858H239.014V165.319H11.1207V20.7858Z"
      fill="#4B4B4B"
    />
    <defs>
      <linearGradient
        id="car_parts_paint0_linear"
        x1="89.8791"
        y1="127.062"
        x2="94.3849"
        y2="113.765"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.25" stopOpacity="0" />
        <stop offset="0.598958" stopOpacity="0.3" />
        <stop offset="1" stopOpacity="0.8" />
      </linearGradient>
      <linearGradient
        id="car_parts_paint1_linear"
        x1="142.423"
        y1="144.992"
        x2="149.73"
        y2="128.161"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0" />
        <stop offset="0.5" stopColor="#808080" stopOpacity="0.5" />
        <stop offset="1" />
      </linearGradient>
      <linearGradient
        id="car_parts_paint2_linear"
        x1="53.7772"
        y1="152.174"
        x2="61.9247"
        y2="133.877"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.25" stopOpacity="0" />
        <stop offset="0.598958" stopOpacity="0.3" />
        <stop offset="1" stopOpacity="0.8" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
